module.exports = __webpack_public_path__ + "static/media/soundHire.59df0518.jpg";